import { LOAD_ADVERTS } from "../actions";
import { AdData, Ad } from "../types";

export const initialState = {
	ads: null as Ad[],
	rotate: false,
	feedFrequency: 10,
} as AdData;

export type DealsState = typeof initialState;

export default function (state = initialState, action) {
	switch (action.type) {
		case LOAD_ADVERTS: {
			return {
				...action.adverts,
				rotate: true,
			};
		}

		case "@@router/LOCATION_CHANGE": {
			return {
				...state,
				rotate: true,
			};
		}

		default:
			return {
				...state,
				rotate: false,
			};
	}
}
